import { useId } from "react";
import { useMutation } from "@apollo/client";
import { routedClient } from "react-migration/lib/persistence/apollo";
import UPDATE_SITE from "react-migration/domains/sites/apollo/li-api/mutations/updateSite.gql";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { Textarea } from "@landtechnologies/components";
import logSiteCardEvent from "src/js/view/sites/logSiteCardEvent";

interface DescriptionProps {
  siteId: string;
  value?: string;
}

export function Description({ siteId, value }: DescriptionProps) {
  const { t } = useTranslation();
  const descriptionId = useId();

  const [updateSite] = useMutation(UPDATE_SITE, {
    client: routedClient,
  });

  return (
    <>
      <label
        htmlFor={`description-${descriptionId}`}
        className="atlas-block atlas-mb-1 atlas-text-sm atlas-font-medium atlas-text-neutral-600"
      >
        {t("sites.card.summary.description")}
      </label>
      <Textarea
        id={`description-${descriptionId}`}
        defaultValue={value ?? ""}
        onChange={(notes) => {
          updateSite({
            variables: { updateData: { _id: siteId, notes } },
          });
          logSiteCardEvent({ name: "Site Card Summary Tab - Description Updated" });
        }}
        placeholder={t("sites.card.summary.no_description_has_been_entered_yet")}
        debounceValue={500}
      />
    </>
  );
}
